import { useParams } from 'react-router-dom'
import { CompletionStatus, SectionName } from '_gql'

import { useGetApplicationProgress } from './GetApplicationProgress.gql'

export interface UseApplicationStatusProps {
  sectionName: SectionName
}

export const useApplicationProgress = ({ sectionName }: UseApplicationStatusProps) => {
  const { appId } = useParams()

  const { data } = useGetApplicationProgress({
    variables: {
      creditApplicationId: appId ?? '',
    },
  })

  const sectionInfo = data?.creditApplication?.savedSectionsInfo?.find(
    (section) => section && section.sectionName === sectionName,
  ) ?? { completionStatus: null }

  return sectionInfo?.completionStatus ?? CompletionStatus.UNSTARTED
}
